import { useState, useEffect } from "react";
import { Calendar } from "@/components/ui/calendar";
import { Calendar as CalendarIcon } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn, getRequestOptions } from "@/lib/utils";
import { format } from "date-fns";
import ClassCard from "./ClassCard";
import { useTranslation } from 'react-i18next';

const HistoricalClasses = () => {
  const { t } = useTranslation();
  const [date, setDate] = useState<Date>();
  const [historicalClasses, setHistoricalClasses] = useState<any[]>([]);

  const fetchClasses = async () => {

    try {
      const response = await fetch(`${import.meta.env.VITE_BOOKING_CLASSES_ENDPOINT}` + '?type=historical', getRequestOptions());

      if (!response.ok) {
        throw new Error('Failed to fetch classes');
      }

      const data = await response.json(); // Parse JSON data

      const filteredClasses = date
        ? data.filter((classItem) => {
          const classDate = new Date(classItem.date);
          return (
            classDate.getMonth() === date.getMonth() &&
            classDate.getFullYear() === date.getFullYear()
          );
        })
        : data;
      setHistoricalClasses(filteredClasses); // Store the retrieved classes in state

    } catch (error) {
      console.error('Error fetching classes:', error);
    }
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">{t('dashboard.historicalClasses')}</h2>
        {/* <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className={cn(
                "justify-start text-left font-normal",
                !date && "text-muted-foreground"
              )}
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {date ? format(date, "MMMM yyyy") : t('common.pickMonth')}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0">
            <Calendar
              mode="single"
              selected={date}
              onSelect={setDate}
              initialFocus
            />
          </PopoverContent>
        </Popover> */}
      </div>

      {historicalClasses.length === 0 ? (
        <Alert className="max-w-lg mx-auto mb-8">
          <AlertDescription>
            {date ? t('classes.noClassesAvailableClearFilter') : t('classes.noClassesAvailable')}
          </AlertDescription>
        </Alert>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {historicalClasses.map((classItem) => (
            <ClassCard key={classItem.id}
              classItem={classItem}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HistoricalClasses;